<template>
  <span v-if="variant === 'tag'" :class="`confidence ${confidence.toLowerCase()}-tag`"> {{ tagLabel[confidence] }} </span>
  <span v-else-if="variant === 'text'" :class="`${confidence.toLowerCase()}-text`">{{ text }} </span>
  <span v-else class="description-text">{{ text }} </span>
</template>

<script>
export default {
  name: 'ConfidenceTag',
  props: {
    confidence: {
      type: String,
      validator: (value) => ['HIGHER', 'HIGH', 'MEDIUM', 'LOW', 'LOWER'].includes(value),
    },
    variant: {
      type: String,
      validator: (value) => ['tag', 'text', 'description'].includes(value),
      default: 'tag',
    },
    text: {
      type: String,
    },
  },
  data: () => ({
    tagLabel: {
      HIGHER: 'Altíssima',
      HIGH: 'Alta',
      MEDIUM: 'Média',
      LOW: 'Baixa',
      LOWER: 'Baixíssima',
    },
  }),
}
</script>

<style lang="scss" scoped>
.confidence {
  border-radius: 4px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  padding: 0px 6px;
  font-size: 14px;
  color: $cinza-d20 !important;
}
.description-text {
  color: $marca-1;
  font-weight: 700;
}
.higher-text {
  color: #71e37c;
  font-weight: 600;
}
.high-text {
  color: #92ffbe;
  font-weight: 600;
}
.medium-text {
  color: #88f4d3;
  font-weight: 600;
}
.low-text {
  color: #88e6ed;
  font-weight: 600;
}
.lower-text {
  color: #99e0ff;
  font-weight: 600;
}
.higher-tag {
  background: #71e37c;
}
.high-tag {
  background: #92ffbe;
}
.medium-tag {
  background: #88f4d3;
}
.low-tag {
  background: #88e6ed;
}
.lower-tag {
  background: #99e0ff;
}
</style>
